<template>
    <div class="container">
        <div class="columns has-text-centered is-vcentered">
            <div class="column price-img">
                <h4>prices</h4>
            </div>
            <div class="column">
                <a name="prices"></a>
                <font-awesome-icon icon="pound-sign" class="fa is-hidden-mobile" />
                <br>
                <!--                <h3 class="statement">prices</h3>-->
                <br />
                <div class="columns is-mobile">
                    <div class="column has-text-right">
                        <p class="day">Adult (12 +)</p>
                        <p class="day">Child (0 - 11)</p>
                        <p class="day">Legend (over 65)</p>
                        <p class="day">Skin Fade</p>
                        <p class="day">Beard</p>
                    </div>
                    <div class="column has-text-left">
                        <p class="day">13</p>
                        <p class="day">10.50</p>
                        <p class="day">11</p>
                        <p class="day">16</p>
                        <p class="day">7</p>
                    </div>

                </div>
            </div>
        </div>
        <hr />
    </div>
</template>
<script>
    export default {
        name: 'prices'
    }

</script>
<style scoped>
    @import url('https://fonts.googleapis.com/css?family=Major+Mono+Display');

    h4 {
        font-family: 'Major Mono Display', monospace;
        font-weight: 800;
        font-size: 1.5rem;
        color: white;
        padding-top: 190px;

    }
    
    .is-white {
        
        color: white;
    }
    
    .divider {

        margin-bottom: 35px;

    }

    .container {

        margin-top: 25px;
        margin-bottom: 25px;

    }

    .statement {

        margin-top: 10px;

    }

    .fa {

        font-size: 5rem;

    }

    .time-img {

        background-image: url('../assets/logan-mountain.jpg');
        border-radius: 6px 6px 6px 6px;
        -moz-border-radius: 6px 6px 6px 6px;
        -webkit-border-radius: 6px 6px 6px 6px;
        background-size: cover;
        width: 100%;
        height: 450px;

    }

    .price-img {

        background-image: url('../assets/logan-boat.jpg');
        border-radius: 6px 6px 6px 6px;
        -moz-border-radius: 6px 6px 6px 6px;
        -webkit-border-radius: 6px 6px 6px 6px;
        background-size: cover;
        width: 100%;
        height: 450px;

    }

</style>
